export default __webpack_public_path__ + "static/media/207.6fbf7028.gif";